import { toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "subHeader" }
const _hoisted_2 = { class: "subHeader__wraper" }
const _hoisted_3 = { class: "subHeader__title" }
const _hoisted_4 = { class: "subHeader__subtext" }
const _hoisted_5 = { class: "subHeader__action createAction" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "triangle" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "whiteBlock" }, null, -1)
const _hoisted_8 = {
  key: 1,
  class: "subHeader__action closeAction"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", null, [
          _createVNode("h1", null, _toDisplayString(_ctx.title), 1),
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.subText), 1)
        ])
      ]),
      (_ctx.canCreate)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("a", {
                href: "#",
                class: "createAction__btn",
                onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.openOrderModal()), ["prevent"]))
              }, "Создать")
            ]),
            _hoisted_7
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("", true),
      (_ctx.canClose)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: _ctx.trip,
              class: "closeAction__btn bigCloseIcon"
            }, null, 8, ["to"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}